import { render, staticRenderFns } from "./DropdownFilterWidget.vue?vue&type=template&id=50db9cc0&scoped=true&"
import script from "./DropdownFilterWidget.vue?vue&type=script&lang=js&"
export * from "./DropdownFilterWidget.vue?vue&type=script&lang=js&"
import style0 from "./DropdownFilterWidget.vue?vue&type=style&index=0&id=50db9cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db9cc0",
  null
  
)

export default component.exports